import { SessionInfo } from "../data/SessionInfo";
import { IStore } from "../services/LocalStorage/IStore";
import { IMainService } from "../services/soap/main/MainService";
import { LoginRequest } from "../services/soap/main/requests/LoginRequest";
import { OneTimeStorage } from "../services/LocalStorage/OneTimeStorage";
import { Organization, Status } from "../services/soap/main/responses/LoginResponse";

type DoLoginResponse = {
    status: boolean;
    message: string;
    session: SessionInfo | undefined;
}

export async function doLogin(
    username: string, 
    password: string, 
    server:string, 
    mainService:IMainService,
    store: IStore
  ):Promise<DoLoginResponse> {
    const result = await mainService.login(
        new LoginRequest(username, password, server)
      );
      if (result.result === "OK") {
        if(store.SessionId !== result.session) {
          await OneTimeStorage.getInstance().clear();
        }
        store.SessionId = result.session;
        
        let session: SessionInfo = {
          session: result.session,
          server: server,
          userId: result.userId,
          organization: result.ORGANIZATION,
          sessionInfo: result.SESSIONINFO,
          userPreferences: result.USER_PREFERENCES,
        };
        
        return {
            status: true,
            message: "",
            session: session
        }
      } else {
        return {
            status: false,
            message: result.EXCEPTION.message + " " + result.EXCEPTION.reason,
            session: undefined
        }
      }        
}

export enum TypeOfWorkBinding{
  Event = 1,
  Task = 2,
  Timesheet = 4,
  Expense = 8,
  Issue = 16
}
export function getTypeOfWorkFromLogin(
  binding: TypeOfWorkBinding,
  organization: Organization
): Status[] {
    const result = organization.OBJECT_SETTINGS.SCHEDULER.TYPES_OF_WORK.TYPE_OF_WORK.filter(status => +status.validFor & binding);
    return result;
}